export default function TelegramIcon({ className }) {
    return (
      <svg className={className} width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1595_7028)">
              <path d="M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z"
                    fill="#203B3F" />
              <path fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.6747 27.7044C20.8373 24.1481 26.2803 21.8036 29.0037 20.6708C36.7796 17.4365 38.3953 16.8747 39.4485 16.8562C39.6801 16.8521 40.198 16.9095 40.5335 17.1817C40.8167 17.4115 40.8947 17.722 40.932 17.94C40.9693 18.1579 41.0157 18.6543 40.9788 19.0422C40.5574 23.4697 38.7341 34.214 37.8065 39.1728C37.414 41.2711 36.6412 41.9746 35.893 42.0435C34.267 42.1931 33.0323 40.9689 31.4574 39.9365C28.993 38.3211 27.6008 37.3155 25.2087 35.7392C22.4442 33.9174 24.2363 32.9161 25.8118 31.2798C26.2241 30.8516 33.3884 24.3351 33.527 23.744C33.5444 23.67 33.5605 23.3945 33.3967 23.2489C33.233 23.1034 32.9914 23.1532 32.817 23.1928C32.5699 23.2489 28.633 25.851 21.0065 30.9991C19.889 31.7664 18.8768 32.1403 17.97 32.1207C16.9702 32.0991 15.0471 31.5554 13.6175 31.0907C11.864 30.5207 10.4703 30.2194 10.5917 29.2514C10.6549 28.7471 11.3492 28.2315 12.6747 27.7044Z"
                    fill="white" />
          </g>
          <defs>
              <clipPath id="clip0_1595_7028">
                  <rect width="56" height="56" fill="white" />
              </clipPath>
          </defs>
      </svg>
    )
}
